import { render, staticRenderFns } from "./Page7.vue?vue&type=template&id=b8d74f34&scoped=true&"
import script from "./Page7.vue?vue&type=script&lang=js&"
export * from "./Page7.vue?vue&type=script&lang=js&"
import style0 from "./Page7.vue?vue&type=style&index=0&id=b8d74f34&prod&lang=css&"
import style1 from "./Page7.vue?vue&type=style&index=1&id=b8d74f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d74f34",
  null
  
)

export default component.exports